const theme = {
  breakpoints: {
    mobile: "max-width: 768px",
    tablet: "max-width: 1024px",
  },
  fontSizes: {
    // Fluid typography using clamp(min, preferred, max)
    mini: "clamp(0.60rem, 0.80vw, 0.70rem)", // ~12px
    xs: "clamp(0.75rem, 0.9vw, 0.85rem)", // ~12px
    sm: "clamp(0.875rem, 1vw, 1rem)", // ~14-16px
    base: "clamp(1rem, 0.95vw, 0.95rem)", // ~16-18px
    md: "clamp(1.125rem, 1.5vw, 1.25rem)", // ~18-20px
    lg: "clamp(1.5rem, 2vw, 2rem)", // ~24-32px
    xl: "clamp(2rem, 3vw, 3rem)", // ~32-48px
    xxl: "clamp(2rem, 5vw, 3.5rem)", // ~48-80px
  },
  letterSpacing: {
    tight: "-0.015em",
    normal: "0.025em",
    wide: "0.05em",
    wider: "0.1em",
  },
};

export default theme;
